import React from 'react';
import { observer } from 'mobx-react-lite';

import { RightSideBarMenu } from '@trader/components';

import { useMst, TSideOfSidebar } from '@trader/store';

export const RightBar: React.FC = observer(() => {
  const store = useMst();

  const sidebar = store.ui.sidebar;
  const layoutType = store.pages.trading.layout.layoutType;

  const onToggleSideBar = (type: TSideOfSidebar) => () => {
    sidebar.toggle(type);
  };

  if (layoutType !== 'single') {
    return null;
  }

  return (
    <RightSideBarMenu
      isOpen={sidebar.isRightOpen}
      onToggleSideBar={onToggleSideBar('isRightOpen')}
    >
      Bar
    </RightSideBarMenu>
  );
});
